import React, { useState } from 'react';
import { 
  Calendar, 
  Plus, 
  Search, 
  User, 
  Globe, 
  Clock, 
  Settings2,
  ChevronDown,
  ChevronUp,
  ExternalLink
} from 'lucide-react';
import './OnlineBooking.css';

const OnlineBooking = () => {
  const [expandedId, setExpandedId] = useState(null);

  const staffAgendas = [
    { id: 1, name: 'ADMINISTRACION GDT', specialty: 'Administración', online: false },
    { id: 2, name: 'DR. SMITH, JOHN', specialty: 'Otorrinolaringología', online: true },
    { id: 3, name: 'LIC. GARCIA, MARIA', specialty: 'Fonoaudiología', online: true },
    { id: 4, name: 'DRA. LOPEZ, ANA', specialty: 'Medicina General', online: true },
  ];

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <div className="online-booking-page">
      <div className="booking-header">
        <div className="booking-title-main">
          <Calendar size={32} className="booking-icon-primary" />
          <div>
            <h1>Configuración de Turnos Online</h1>
            <p>Define qué agendas y profesionales estarán disponibles para reserva web.</p>
          </div>
        </div>
      </div>

      <div className="booking-controls card">
        <div className="search-bar-wrapper">
          <Search size={18} className="search-icon" />
          <input type="text" placeholder="Filtrar agendas..." />
        </div>
      </div>

      <div className="booking-table-container card">
        <table className="booking-table">
          <thead>
            <tr>
              <th>Agenda / Profesional</th>
              <th>Especialidad</th>
              <th className="text-center">Habilitado Web</th>
              <th className="text-center">Configuración</th>
            </tr>
          </thead>
          <tbody>
            {staffAgendas.map(agenda => (
              <React.Fragment key={agenda.id}>
                <tr className={expandedId === agenda.id ? 'row-active' : ''}>
                  <td>
                    <div className="professional-cell">
                      <div className="prof-avatar">
                        <User size={16} />
                      </div>
                      <span className="prof-name">{agenda.name}</span>
                    </div>
                  </td>
                  <td>{agenda.specialty}</td>
                  <td className="text-center">
                    <label className="switch">
                      <input type="checkbox" defaultChecked={agenda.online} />
                      <span className="slider round"></span>
                    </label>
                  </td>
                  <td className="text-center">
                    <button 
                      className={`btn-config-detail ${expandedId === agenda.id ? 'active' : ''}`}
                      onClick={() => toggleExpand(agenda.id)}
                    >
                      <Settings2 size={18} /> {expandedId === agenda.id ? 'CERRAR' : 'DETALLE'}
                    </button>
                  </td>
                </tr>
                {expandedId === agenda.id && (
                  <tr className="booking-detail-row">
                    <td colSpan="4">
                      <div className="booking-detail-content">
                        <div className="detail-grid">
                          <div className="detail-section">
                            <h3>Estudios Disponibles para Web</h3>
                            <div className="studies-selection-list">
                              <label className="checkbox-item">
                                <input type="checkbox" defaultChecked />
                                <span>CONSULTA GENERAL</span>
                              </label>
                              <label className="checkbox-item">
                                <input type="checkbox" defaultChecked />
                                <span>PRIMERA VEZ</span>
                              </label>
                              <label className="checkbox-item">
                                <input type="checkbox" />
                                <span>CONTROL / SEGUIMIENTO</span>
                              </label>
                            </div>
                          </div>

                          <div className="detail-section">
                            <h3>Reglas Específicas</h3>
                            <div className="rules-form">
                              <div className="form-group-inline">
                                <label>Duración del Turno (Web)</label>
                                <select defaultValue="15">
                                  <option value="15">15 minutos</option>
                                  <option value="20">20 minutos</option>
                                  <option value="30">30 minutos</option>
                                </select>
                              </div>
                              <div className="form-group-inline">
                                <label>Intervalo de Agregación</label>
                                <select defaultValue="15">
                                  <option value="15">Cada 15 min</option>
                                  <option value="30">Cada 30 min</option>
                                </select>
                              </div>
                            </div>
                            
                            <div className="portal-preview-link">
                              <Globe size={16} />
                              <a href="#" onClick={(e) => e.preventDefault()}>Ver perfil en el Portal</a>
                              <ExternalLink size={14} />
                            </div>
                          </div>
                        </div>

                        <div className="notes-section">
                          <h3>Notas / Instrucciones para el Paciente</h3>
                          <textarea 
                            placeholder="Ej: Solo atiende pacientes con derivación previa..."
                            rows="2"
                          ></textarea>
                          <p className="hint">Este mensaje aparecerá cuando el paciente seleccione a este profesional.</p>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OnlineBooking;
